// @flow

import { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import type { LogInActionCreator } from '../common/typings';
import PinPad from '../common/components/PinPad/PinPad';
import { WORK_AREA_WIDTH } from '../constants';

const HALF_OF_THE_PIN_PAD_WIDTH = 126;

const CenterVertically = styled.div`
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  flex-shrink: 0;
  display: ${props => (props.isVisible ? 'flex' : 'none')};
`;

type Props = {
  shouldShow: boolean,
  pinPadInitialMount: boolean,
  deviceWidth: number,
  deviceHeight: number,
  logIn: LogInActionCreator
};

type State = {
  isVisible: boolean,
  pinPadPosition: number
};

export default class PinPadScreen extends PureComponent<Props, State> {
  componentDidMount() {
    this.setPinPadPosition(this.props.deviceWidth);
  }

  state = {
    isVisible: true,
    pinPadPosition: 0
  };

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps({ shouldShow, deviceWidth }: Props) {
    if (shouldShow && !this.props.shouldShow) {
      this.setState({ isVisible: true });
    }

    if (deviceWidth !== this.props.deviceWidth) {
      this.setPinPadPosition(deviceWidth);
    }
  }

  setPinPadPosition(deviceWidth: number) {
    if (deviceWidth <= WORK_AREA_WIDTH) {
      const pixelsToCenter = (WORK_AREA_WIDTH - 2 * HALF_OF_THE_PIN_PAD_WIDTH) / 2;
      this.setState({
        pinPadPosition: HALF_OF_THE_PIN_PAD_WIDTH + pixelsToCenter
      });
    } else {
      this.setState({
        pinPadPosition: HALF_OF_THE_PIN_PAD_WIDTH + deviceWidth / 5
      });
    }
  }

  onVisibilityChange = (isVisible: boolean) => {
    this.setState({ isVisible });
  };

  render() {
    const { shouldShow, logIn, pinPadInitialMount, deviceWidth, deviceHeight } = this.props;

    return (
      <CenterVertically
        isVisible={this.state.isVisible}
        pinPadPosition={this.state.pinPadPosition}
        deviceWidth={deviceWidth}>
        <PinPad
          logIn={logIn}
          pinPadInitialMount={pinPadInitialMount}
          shouldShow={shouldShow}
          onVisibilityChange={this.onVisibilityChange}
          deviceHeight={deviceHeight}
          deviceWidth={deviceWidth}
        />
      </CenterVertically>
    );
  }
}

PinPadScreen.propTypes = {
  logIn: PropTypes.func,
  shouldShow: PropTypes.bool,
  pinPadInitialMount: PropTypes.bool,
  deviceWidth: PropTypes.number,
  deviceHeight: PropTypes.number
};
